import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Register from "../views/Register.vue";
import Edit from "../views/Edit.vue";
import AndroidSuccess from "../views/AndroidSuccess.vue";
import IosStep1 from "../views/IOSSuccessStep1.vue";
import IosStep2 from "../views/IOSSuccessStep2.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/edit/:id",
    name: "edit",
    component: Edit
  },
  {
    path: "/android/success/:id",
    name: "androidSuccess",
    component: AndroidSuccess
  },
  {
    path: "/ios/success/1/:id",
    name: "iosStep1",
    component: IosStep1
  },
  {
    path: "/ios/success/2/:id",
    name: "iosStep2",
    component: IosStep2
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
